import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

import Media from './Media';


/**
 * Renders a media lesson block passing the correct medium depending on the url param
 */
class Meditation extends Component {
    static minimumPlayedPercentage = window.MinimumPlayedPercentage || 0;

    static propTypes = {
        medium: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
        }).isRequired,
    };

    static canContinue(answer) {
        return !(Boolean(answer) && answer.playedPercentage >= Meditation.minimumPlayedPercentage);
    }

    render() {
        const {medium, ...props} = this.props;

        return (
            <Media
                {...props}
                config={medium}
                seekable={false}
            />
        );
    }
}

const mapStateToProps = ({media}, {match: {params: {medium}}}) => ({
    medium: media[medium],
});

export default withRouter(connect(mapStateToProps)(Meditation));



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Meditation.js